import React, {FC} from 'react';
import styled from 'styled-components';
import {PriceRangeInput} from '../../FilterContent/Price/PriceRangeInput';
import {PriceRangeManualInput} from '../../FilterContent/Price/PriceRangeManualInput';
import {FilterDropdown} from '../FilterDropdown';

interface Props {
  label: string;
  max: number;
  min: number;
  onApply: (range: [number, number]) => void;
  onChange: (range: [number, number]) => void;
  values: [number, number];
  onFilterReset: () => void;
  hasAppliedPriceRange: boolean;
  currencyCode: string;
  onOpen?: () => void;
  onClose?: () => void;
}

export const FilterDropdownPrice: FC<Props> = ({
  label,
  max,
  min,
  onApply,
  onChange,
  values,
  onFilterReset,
  hasAppliedPriceRange,
  currencyCode,
  onClose,
  onOpen,
}) => {
  const priceRangeCount = hasAppliedPriceRange ? 1 : 0;

  return (
    <FilterDropdown
      dataTestId="filterDropdownPrice"
      activeCount={priceRangeCount}
      label={label}
      onReset={onFilterReset}
      onClose={onClose}
      onOpen={onOpen}
      filterContent={
        <Wrapper>
          <StyledPriceRangeManualInput
            min={min}
            max={max}
            values={values}
            onApply={onApply}
            onChange={onChange}
            currencyCode={currencyCode}
          />
          <PriceRangeInput
            max={max}
            min={min}
            values={values}
            onApply={onApply}
            onChange={onChange}
            currencyCode={currencyCode}
          />
        </Wrapper>
      }
    />
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledPriceRangeManualInput = styled(PriceRangeManualInput)`
  margin-bottom: 12px;
`;
